const WEBSITE_URL: string = 'https://remote.kinomap.dev';
export const API_URL: string = 'https://api.kinomap.dev/v4';
export const APP_TOKEN: string =
  'S7neqcMYgeqE9rby2tY3l4oyIIDJZA467OdeAohgNJmYzsJFt4zmBI3Yflc2g4ZQRDjfhqoDnnbCG8lrkpXkEKgG4cHR5hcBQz7EQegErMyQYI3ibjoa6nt5';
export const WEBSOCKET_URL: string = 'https://wss-remote-v2.kinomap.dev/';

export const environment = {
  external_links: {
    kinomap: 'https://kinomap.dev',
    kinomap_appstore: 'https://apps.apple.com/fr/app/kinomap-v%C3%A9lo-running-rameur/id611177969',
    kinomap_playstore:
      'https://play.google.com/store/apps/details?id=com.kinomap.training&hl=fr&gl=US',
  },
};
